module.exports = __webpack_public_path__ + "static/media/M1-F1-Templo-da-Magia-Arcana-codF4.e4b503d3.png";